import { watch } from 'vue'
import { usePayrollStore } from '@/store/payroll-data'

export function usePayrollChange(callBack: Function) {
  const init = () => {
    const payrollStore = usePayrollStore()
    watch(
      () => payrollStore.payroll,
      payroll => {
        callBack(payroll)
      }
    )
  }
  init()
}
